import React from "react";
import CustomModal from "../Common/CustomModal";
import { Box, Typography, useTheme } from "@mui/material";

const SendInviteModal = ({ open, handleClose, handleInvite }) => {
  const theme = useTheme();

  return (
    <CustomModal
      open={open}
      handleClose={handleClose}
      title={"Confirmation"}
      saveBtnText={"Send"}
      cancelBtnText={"Cancel"}
      onSave={() => {
        handleInvite();
        handleClose();
      }}
      onCancel={() => {
        handleClose();
      }}
      height={"auto"}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          p: 4,
        }}
      >
        <Typography sx={theme.body}>
          Are you sure you want to send the invite?
        </Typography>
      </Box>
    </CustomModal>
  );
};

export default SendInviteModal;
